import { motion } from "framer-motion";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import type { IProduct } from "../types/products";

interface IFunctionsGridProps {
  product?: IProduct;
}

export const ProductFunctionsGrid = ({ product }: IFunctionsGridProps) => {
  const { t } = useTranslation("common");
  const functions = product?.en
    ? product?.en?.PVCDetails?.functions
    : product?.PVCDetails?.functions;

  if (!functions) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 py-6 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8">
      {functions.map((option: string) => (
        <div className="mx-auto my-1 text-center text-orange" key={option}>
          <motion.div
            className="p-2"
            transition={{ damping: 10, stiffness: 400, type: "spring" }}
            whileHover={{ scale: 1.03 }}
          >
            <Image
              alt={option}
              className="mx-auto"
              height={128}
              src={`/img/functions/${option}.png`}
              width={128}
            />
          </motion.div>
          <strong className="my-4 block text-sm">
            {t(`functions.${option}`)}
          </strong>
        </div>
      ))}
    </div>
  );
};
